export default {"src":"/planning/bridesmaid-dress/quiz/_next/static/media/error-403.bd925f08.svg","height":196,"width":402};